import React from 'react';

import { Container, Content, Description } from './styles';

const PolicyContainer = props => {
  return (
    <Container active={props.active}>
      <Content>
        <Description>
          <img
            src="https://cdn1.iconfinder.com/data/icons/unigrid-bluetone-multimedia-vol-6/60/020_256_rules_do_not_list_book_history_education_study_learn_knowledge-512.png"
            alt="Livro"
          />
          <h3>Regra 1 - Adesão à competição Voittocoins</h3>
          <p>
            Todas as pessoas físicas com cadastro único no site da Voitto, na
            plataforma online e com o número de VoittoCoins maior que 0 estarão
            participando da competição.
          </p>
          <h3>Regra 2 – Rodadas</h3>
          <p>
            A competição é dividida em rodadas. Cada rodada tem duração de um
            mês, após esse período o número de Voittocoins é zerado.
          </p>
          <h3>Regra 3 - Contabilidade do Acúmulo:</h3>
          <p>
            Para a classificação dos competidores é utilizado o número
            individual de Voittocoins acumulados no mês, que são
            intransferíveis. O uso dos mesmos em desconto de cursos não implica
            em perda de posição no rankeamento;
          </p>
          <h3>Regra 4 - Atos geradores de Voittocoins: </h3>
          <p> - Evoluir nos cursos: Vt$3 por lição </p>
          <p>- Finalizar um curso: Vt$100 </p>
          <p>- Completar dados cadastrais: Vt$200</p>
          <p> - Utilizar o VoittoAPP: Vt$250</p>

          <h3>Regra 5 - Critérios de desempate: </h3>
          <p> Critério 1 - Quantidade de cursos inscritos </p>
          <p> Critério 2 - Quantidade de cursos compartilhados </p>
          <p> Critério 3 - Total de cursos concluídos</p>

          <h3>Regra 6 - Prêmios</h3>
          <p>
            A premiação é unica para cada pessoa fisica (CPF) e pode sofrer
            variação entre os meses, podendo ser vista na tabela de rankeamento,
            no ícone de prêmio.
          </p>
          <h3>Regra 7 - VoittoCoins e clubes de assinatura </h3>
          <p>
            É possível utilizar seus VoittoCoins para ganhar descontos nos
            planos dos clubes de assinatura da Voitto. No entanto, os conteúdos
            inclusos nesses planos não geram VoittoCoins.
          </p>
          <p>Regra 8 - Validade dos cursos com VoittoCoins<br />
                    Após a inscrição, os cursos adquiridos 100% por VoittoCoins ficarão disponíveis por 90 dias no Portal do Aluno.
                    </p>
                    <p>Regra 9. Cancelamento de curso 100% VoittoCoins<br />
                    Não é possível solicitar reembolso de um treinamento pago com 100% de VoittoCoins.
                    </p><br/>
                    <br/><br/><br/><br/><br/><br/>
        </Description>

        <footer>
          <button onClick={() => props.handler()} aria-label="Entendi">
            Entendi
          </button>
        </footer>
      </Content>
    </Container>
  );
};

export default PolicyContainer;
